import SetInboxRuleResponse from 'owa-service/lib/contract/SetInboxRuleResponse';
import InboxRule from 'owa-service/lib/contract/InboxRule';
import SetInboxRuleData from 'owa-service/lib/contract/SetInboxRuleData';
import setInboxRuleRequest from 'owa-service/lib/factory/setInboxRuleRequest';
import setInboxRuleOperation from 'owa-service/lib/operation/setInboxRuleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

/**
 * Set inbox rule service
 * @param inboxRule the rule to update
 * @return SetInboxRuleResponse
 */
export default function setInboxRuleService(
    inboxRule: InboxRule,
    force?: boolean,
    alwaysDeleteOutlookRulesBlob?: boolean
): Promise<SetInboxRuleResponse> {
    let requestBody = setInboxRuleRequest({
        Header: getJsonRequestHeader(),
        InboxRule: inboxRule as SetInboxRuleData,
    });
    requestBody.Force = force;
    requestBody.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;

    return setInboxRuleOperation(requestBody);
}
